// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ebff5a44","455":"bc7fb714","977":"2b039925"}[chunkId] + ".chunk.js";
};